export const IDTypelist = {
    "身份证": 'RNS-IDNO',
    "护照": 'RNS-PASSNO',
    "台胞证": 'RNS-TWNO',
    "港澳通行证": 'RNS-HKMONO',
}
export const TBCActions = new Map([
    ["TBC", "待审核"],
    ["CFM", "已通过"],
    ["RFS", "已拒绝"],
    ["PAID", "已付费"],
    ["NOPAID", "未付费"],
    ["Complete", "已购票"],
    ["NoCode", "无效票"],
]);
export const Personal_inputs = [{
        name: "身份证姓名",
        code: "Surname",
        holder: "请输入身份证姓名",
        rules: [{
            required: true,
            message: "请输入正确身份证姓名"
        }],
    },
    {
        name: "手机（请填写参会人本人手机号）",
        code: "Mobile",
        holder: "请输入手机",
        rules: [{
            required: true,
            pattern: /^\d{11}$/,
            message: "请输入正确手机"
        }, ],
    },
    // {
    //     name: "验证码",
    //     code: "VerifyCode",
    //     holder: "请输入验证码",
    //     rules: [{
    //         required: true,
    //         pattern: /^\d{6}$/,
    //         message: "请输入正确验证码"
    //     }, ],
    // },
    {
        name: "邮箱",
        code: "Email",
        holder: "请输入邮箱",
        rules: [{
            required: true,
            pattern: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/,
            message: "请输入正确邮箱",
        }, ],
    },
    {
        name: "公司",
        code: "CompanyName",
        holder: "请输入公司名称",
        rules: [{
            required: true,
            message: "请输入公司名称"
        }, ],
    },
    {
        name: "职位",
        code: "Position",
        holder: "请输入职位",
        rules: [{
            required: true,
            message: "请输入职位"
        }, ],
    },
    {
        name: "证件类型",
        code: "cardType",
        holder: "证件类型",
        rules: [{
            required: true,
            message: "请选择证件类型",
        }, ],
        isSelect: true,
    },
    {
        name: "证件号码",
        code: "cardNO",
        holder: "请输入证件号码",
        rules: [],
    },
]
import {
    CheckCard
} from '@/utils/checkcard.js'
export function cardNOValidator(val) {
    console.log(val);
    return true;
}